import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Container, Row, Col } from 'react-grid-system';
import classNames from 'classnames/bind';

import styles from './docs.module.scss';

const cx = classNames.bind(styles);

class EmailSecurity extends Component {

  constructor(props) {
    super(props);
    this.state = {
      frameHeight: 0,
      loadDone: false,
    };
  }

  componentDidMount() {
    console.log('componentDidMount');
    this._onLoad('A');
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { loadDone } = nextState;
    return loadDone;
  }

  render() {
    const { frameHeight } = this.state;

    return (
      <Container className={cx('container')}>
        <Row>
          <Col xs={12} lg={10} offset={{ lg: 1 }}>
            <iframe
              title="이메일무단수집거부"
              src="/static/pages/email-security.html"
              scrolling="no"
              frameBorder="0"
              width="100%"
              height={`${frameHeight}px`}
              onLoad={() => this._onLoad('B')}
            />
          </Col>
        </Row>
      </Container>
    );
  }

  _onLoad = () => {
    const obj = ReactDOM.findDOMNode(this);
    const iframe = obj.childNodes[0].childNodes[0].childNodes[0];
    const { body } = iframe.contentWindow.document;

    if (body) {
      this.setState({
        frameHeight: body.scrollHeight,
        loadDone: true,
      });
    }
  }
}

export default EmailSecurity;